import { render, staticRenderFns } from "./ConstructionForm.vue?vue&type=template&id=8190d506&"
import script from "./ConstructionForm.vue?vue&type=script&lang=js&"
export * from "./ConstructionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports